<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <action-toolbar-count [grid]="grid"></action-toolbar-count>
            <action-toolbar-buttons
                [grid]="grid"
                [canEdit]="canEdit"
                [showAdd]="true"
                [showEdit]="true"
                [showDelete]="true"
            ></action-toolbar-buttons>
        </form>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <wj-flex-grid
            id="mainGrid"
            #mainGrid
            appAutoSize
            [minHeight]="70"
            (initialized)="grid.initialize(mainGrid)"
            (destroy)="grid.destroy()"
            [itemsSource]="grid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Title'" [binding]="'title'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Subheading'" [binding]="'subheading'" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Type'" [binding]="'pageType'" [dataMap]="pageTypeMap" [width]="'*'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Duration (minutes)'" [binding]="'duration'" [width]="'*'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
